export default __webpack_public_path__ + "static/media/eventosCiudad.f2b1f1ee.png";